export default __webpack_public_path__ + "static/media/line.75ce07e0.png";